import {
  connectFunctionsEmulator,
  getFunctions,
  httpsCallable
} from 'firebase/functions'
import { getApp } from './firebase'
import { FUNCTION_REGION, IS_DEV } from '../config'

const functions = getFunctions(getApp(), FUNCTION_REGION)

if (IS_DEV) {
  connectFunctionsEmulator(functions, 'localhost', 5001)
}

export const magicAuth = httpsCallable(functions, 'auth')

export const completeOnboarding = httpsCallable(functions, 'completeOnboarding')

export const subscribeNewsletter = httpsCallable(
  functions,
  'subscribeNewsletter'
)

export const requestWalletAuth = httpsCallable(functions, 'requestWalletAuth')
export const grantWalletAuth = httpsCallable(functions, 'grantWalletAuth')
